import React from "react";
import { twMerge } from "tailwind-merge";
import useETFormState from "./useETFormState";
import { notMandatoryFields } from "./additionalFields";

const InputText = ({
  label,
  value,
  placeholder,
  name,
  updateForm,
  className,
  inputType = "text",
  searchedSkill,
  updateSkills,
  formData,
}) => {
  return (
    <div
      className={twMerge(
        `relative flex flex-col gap-2 font-unilever-shilling-normal text-[12px] ${className}`
      )}
    >
      <label className="my-0 font-unilever-shilling-normal text-[13px]">
        {label}
        {!notMandatoryFields.includes(name) && "*"}
      </label>
      <input
        className="!border !border-[#C8D3DE] p-2 outline-none"
        type={inputType}
        name={name}
        id=""
        placeholder={placeholder}
        value={value}
        onChange={(e) => updateForm(e.target.name, e.target.value)}
      />
      {searchedSkill && searchedSkill.type === name && (
        <div className="flex items-center gap-1">
          <input
            type="checkbox"
            name={name}
            onChange={() => updateSkills(name, searchedSkill.id)}
            value={searchedSkill.id}
            checked={formData[name].includes(searchedSkill.id)}
          />
          <label className="!my-0 text-[11px]">
            {searchedSkill.id} - {searchedSkill.name}
          </label>
        </div>
      )}
      {formData?.[name] && (
        <div className="flex items-center gap-1">
          Skill List:{" "}
          {formData[name].length > 1
            ? formData[name]
                .split(",")
                .map((item, idx) => <span key={idx}>{item}</span>)
            : formData[name]}
        </div>
      )}
    </div>
  );
};

export default InputText;
